import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import spreadsheetValidations from './spreadsheetValidations'

export class CheckPrepared extends Component {
  state = {
    departmentLists: [],
    selectedDepartment: '',
    department: ['']
  }

  render () {
    let invalid = this.props.grid

    const invalidData = invalid.filter(crf =>
      spreadsheetValidations.checkPepared({
        paymentRef: crf[5].value,
        checkAvailable: crf[6].value,
        checkDate: crf[7].value
      })
    )
      
    const gridWithInput = this.props.grid.filter(
      crf =>
        crf[5].value !== '' &&
        crf[5].value !== 'Payment Ref' &&
        crf[6].value !== '' &&
        crf[6].value !== 'Check Available Date'
    )

    return (
      <div id='modalBody' className='modalBody'>
        <div className='modalContainer'>
          <div className='modalbg'>
            <div id='modalContentDashboard'>
              <div className='updatingChecksContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <h4 className='returnHeader'>Nothing To Update</h4>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <h4>Update to Check Available</h4>
                        <h5 className='returnHeader'>
                          Are you sure you want to proceed? Please confirm.
                        </h5>
                      </>
                    ) : (
                      <h4 style={textRed}>Error</h4>
                    )}
                  </>
                )}

                {invalidData.map(crf => (
                  <div className='updatingChecksContent'>
                    <div className='inProcessCrfDetail'>
                      <span>CRF#:{crf[1].value}</span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span style={crf[5].value === '' ? textRed : null}>
                        Payment Ref:
                        {crf[5].value === '' ? 'Empty' : crf[5].value}
                      </span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          spreadsheetValidations.dates(crf[6].value)
                            ? textRed
                            : null
                        }
                      >
                        Check Available Date:
                        {crf[6].value === ''
                          ? 'Empty'
                          : spreadsheetValidations.dates(crf[6].value)
                          ? 'Invalid'
                          : crf[6].value.trim()}
                      </span>
                    </div>
                    <div className='inProcessCrfDetail'>
                      <span
                        style={
                          spreadsheetValidations.dates(crf[7].value)
                            ? textRed
                            : null
                        }
                      >
                        Check Date:
                        {crf[7].value === ''
                          ? 'Empty'
                          : spreadsheetValidations.dates(crf[7].value)
                          ? 'Invalid'
                          : crf[7].value.trim()}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              {gridWithInput.length === 0 && invalidData.length === 0 ? null : (
                <>
                  {invalidData.length === 0 &&
                  gridWithInput.length !== 0 ? null : (
                    <div className='returnHeader'>
                      <h6>Date must be valid and in MM/DD/YY format</h6>
                    </div>
                  )}
                </>
              )}

              <div className='updateToCheckPrepareButtonContainer'>
                {gridWithInput.length === 0 && invalidData.length === 0 ? (
                  <>
                    <button
                      className='updateToCheckPrepareCloseButton'
                      onClick={this.props.closeModal}
                    >
                      Ok
                    </button>
                  </>
                ) : (
                  <>
                    {invalidData.length === 0 && gridWithInput.length !== 0 ? (
                      <>
                        <button
                          className='updateToCheckPrepareCloseButton'
                          onClick={this.props.closeModal}
                        >
                          Cancel
                        </button>
                        <button
                          className='updateToCheckPrepareUpdateButton'
                          onClick={this.props.handleUpdateToCheckAvailable}
                        >
                          Confirm
                        </button>
                      </>
                    ) : (
                      <button
                        className='updateToCheckPrepareCloseButton'
                        onClick={this.props.closeModal}
                      >
                        Close
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const textRed = {
  color: 'red'
}

export default CheckPrepared
